import { render } from "./StandardsBlock.vue?vue&type=template&id=11058639&scoped=true"
const script = {}

import "./StandardsBlock.vue?vue&type=style&index=0&id=11058639&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11058639"]])

export default __exports__